import React from 'react'
import Footer from './Footer'
import prod1 from '../img/product1.jpg'
import prod2 from '../img/product2.jpg'
import prod3 from '../img/product3.jpg'
import prod4 from '../img/product4.jpg'
import prod5 from '../img/product5.jpg'
import prod6 from '../img/product6.jpg'
import prod7 from '../img/product7.jpg'
import prod8 from '../img/product8.jpg'
import prod9 from '../img/product9.jpg'
import prod10 from '../img/product10.jpg'
import prod11 from '../img/product11.jpg'
import prod12 from '../img/product12.jpg'
import prod13 from '../img/product13.jpg'
import prod14 from '../img/product14.jpg'

const Services = () => {
  return (
    <>

      <div className='container mt-1 bg-success p-2 d-flex justify-content-center align-items-center rounded-3' >
        <h2 className="text-center mb-1 text-white">Our Products</h2>
      </div>


      <div className='products'>

        <div className='products2'>
          <img src={prod1} />
        </div>

        <div className='products2'>
          <img src={prod2} />
        </div>

        <div className='products2'>
          <img src={prod3} />
        </div>

      </div>




      <div className='products'>

        <div className='products2'>
          <img src={prod4} />
        </div>

        <div className='products2'>
          <img src={prod5} />
        </div>

        <div className='products2'>
          <img src={prod6} />
        </div>

      </div>


       <div className='products'>

                <div className='products2'>
                    <img src={prod7} />
                </div>

                <div className='products2'>
                    <img src={prod8} />
                </div>

                <div className='products2'>
                    <img src={prod9} />
                </div>

            </div>



            <div className='products'>

                <div className='products2'>
                    <img src={prod10} />
                </div>

                <div className='products2'>
                    <img src={prod11} />
                </div>

                <div className='products2'>
                    <img src={prod12} />
                </div>

            </div>


            <div className='products'>

                <div className='products2'>
                    <img src={prod13} />
                </div>

                <div className='products2'>
                    <img src={prod14} />
                </div>



            </div>





      <Footer />
    </>
  )
}

export default Services